import React from 'react'

import stats from "../Image/gitstats.jpg"
export const GitHub = () => {
    return (

        <section className="react-activity-calendar">
            <div className="heading">
                <h2>GitHub Statistics</h2>
                <span>& Calender</span>
            </div>
            <br />
            {/* <div className="calendar">
                <!-- Loading the data just for you. -->
                <img src={stats} alt="stats" width={"100"} />
            </div> */}
            <br />
            <div id="git-stat">
                <div className="gitSt">
                    <img id="github-streak-stats"
                        src="https://github-readme-streak-stats.herokuapp.com?user=wdwithsuraj&theme=react&border_radius=6.5&date_format=M%20j%5B%2C%20Y%5D"
                        alt="streak-stat" />
                    <br />
                    <img id="github-stats-card"
                        src="https://github-readme-stats.vercel.app/api?username=wdwithsuraj&count_private=true&theme=react"
                        alt="stat-card" />
                </div>
                <div className="gitSt2">
                    <img id="github-top-langs"
                        src="https://github-readme-stats.vercel.app/api/top-langs/?username=wdwithsuraj&theme=react"
                        alt="top_languages" />
                </div>
            </div>
        </section>
    )
}
